import Tag from '@/components/ui/Tag'
import type { Project } from '@/types'

interface ProjectInfoProps {
  project: Project
}

export default function ProjectInfo({ project }: ProjectInfoProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-[320px_1fr] gap-8 md:gap-12">
      <div className="flex flex-col gap-6">
        <div>
          <span className="text-label uppercase tracking-widest text-text-muted">Role</span>
          <p className="text-body text-text-primary mt-1">{project.role}</p>
        </div>
        <div>
          <span className="text-label uppercase tracking-widest text-text-muted">Date</span>
          <p className="text-body text-text-primary mt-1">{project.date}</p>
        </div>
        <div>
          <span className="text-label uppercase tracking-widest text-text-muted">Tags</span>
          <div className="flex flex-wrap gap-2 mt-2">
            {project.tags.map((tag) => (
              <Tag key={tag} label={tag} />
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4">
        {project.description.split('\n\n').map((para, i) => (
          <p key={i} className="text-body text-text-secondary leading-relaxed">{para}</p>
        ))}
      </div>
    </div>
  )
}
